import { Map } from 'immutable';
import { actionTypes } from '../../../../controller';

const {
	INIT_SOUND_STATUS,
} = actionTypes;
const initialState = Map({
	isTurnOnSound: false,
});

export default function sound(state = initialState, action) {
	switch (action.type) {
		case INIT_SOUND_STATUS: {
			return state.set('isTurnOnSound', true);
		}

		default:
			return state;
	}
}
